module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section07_02_american-village-e2fa579ef57855620f4e61c7c33b359d.jpg";